import React from "react";
import { Link } from "react-router-dom";
import { makeStyles, Tooltip } from "@material-ui/core";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";

import { hasItems, removeItemFromOrder } from "util/APIUtils";

const useStyle = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
  },
  leaders: {
    maxWidth: "40em",
    padding: 0,
    overflowX: "hidden",
    listStyle: "none",
  },
  lineItem: {
    "&::after": {
      float: "left",
      width: 0,
      whiteSpace: "nowrap",
      paddingTop: 10,
      content:
        "'. . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . '",
    },
  },
  brandImage: {
    verticalAlign: "middle",
    width: 36,
    height: 36,
  },
  product: {
    display: "inline-block",
    backgroundColor: "#FAFAFB",
  },
  description: {
    display: "inline-block",
    padding: "10px 0",
  },
  cost: {
    float: "right",
    paddingTop: 10,
    paddingLeft: "0.33em",
    position: "relative",
    zIndex: 1,
    backgroundColor: "#FAFAFB",
  },
  removeButton: {
    float: "right",
    padding: ".5em 0 0 .2em",
    backgroundColor: "#FAFAFB",
    position: "relative",
    width: 28,
    height: 28,
    zIndex: 1,
  },
  total: {
    textAlign: "right",
    paddingRight: "1.7em",
  },
  totalNoOrder: {
    textAlign: "right",
    paddingRight: "1.7em",
    color: "#bbb",
  },
  paidContainer: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "1em 1.7em 0 0",
  },
  paid: {
    textAlign: "center",
    color: "#f00",
    display: "inline-block",
    border: "1px solid red",
    width: 45,
  },
  thankyou: {
    padding: "0 50px 0",
    textAlign: "center",
  },
  udaf: {
    whiteSpace: "nowrap",
  },
  totalAmount: {
    paddingLeft: 8,
  },
  noItemsOnOrder: {
    display: "block",
    textAlign: "center",
    padding: "2em 0 1.2em",
  },
}));

export default function Invoice({
  initiatingBrand,
  paid,
  order,
  updateInvoice,
  enqueueSnackbar,
}) {
  const classes = useStyle();
  const editable = !paid;
  const queryForInitialBrand =
    initiatingBrand &&
    "?query=" +
      encodeURIComponent(
        initiatingBrand.brandNumber + " " + initiatingBrand.position
      );
  const noOrder = hasItems(order);
  const removeLineItem = (lineItemId) => {
    removeItemFromOrder(order.id, lineItemId)
      .then(() => {
        updateInvoice();
      })
      .catch((error) =>
        enqueueSnackbar(
          (error && error.message) ||
            "Some problem removing the order line item " +
              lineItemId +
              " from this order",
          { variant: "error" }
        )
      );
  };

  return (
    <div className="invoice">
      {order && order.items && order.items.length > 0 ? (
        <ul className={classes.leaders}>
          {order.items.map(
            ({ id, brandId, brandImageUrl, description, quantity, amount }) => (
              <li className={classes.lineItem} key={id}>
                <span className={classes.product}>
                  <img
                    src={brandImageUrl}
                    className={classes.brandImage}
                    alt={brandId}
                  />
                  <span className={classes.description}>{description}</span>
                </span>
                <span className={classes.removeButton}>
                  {editable && (
                    <Tooltip title="remove">
                      <HighlightOffIcon
                        aria-label="remove"
                        color="secondary"
                        onClick={() => removeLineItem(id)}
                      />
                    </Tooltip>
                  )}
                </span>
                <span className={classes.cost}>{amount}</span>
              </li>
            )
          )}
        </ul>
      ) : (
        <span className={classes.noItemsOnOrder}>
          No items currently added to your cart.{" "}
          <Link to={`/${queryForInitialBrand ?? "/"}`}>Search for Brands</Link>
        </span>
      )}
      <hr />
      <div className={noOrder ? classes.totalNoOrder : classes.total}>
        Total
        <strong className={classes.totalAmount}>
          {order && (order.total || "$0.00")}
        </strong>
      </div>
      {paid && (
        <div>
          <div className={classes.paidContainer}>
            <strong className={classes.paid}>PAID</strong>
          </div>
          <p className={classes.thankyou}>
            Thank you for renewing your Brand with the{" "}
            <span className={classes.udaf}>
              Utah Division of Animal Industry!
            </span>
          </p>
        </div>
      )}
    </div>
  );
}
